<template lang="pug">
    div
        // h2 Profile Manage
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :userCanBatchEdit="true"
            :userCanBatchDelete="true"
            :userCanSearchByTag="true"
            :userCanSearchDomain="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="searchView"
            :sectionInfo="sectionInfo"
            primarySearchKey="appProfileName"
            :primarySearchKeyI18="$t('domainsetting.appProfileName')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :batchSelector="batchSelector"
            :givenBatchSearchFilters="givenBatchSearchFilters"
            :batchSelectorWith="batchSelectorWith"
        )
            template(slot="tableUpperBtn")
                Button.left-under-table-btn(
                    :disabled="!$can('write', 'domainManagePermission','FQDNConfig')"
                    @click="isBatchClearCacheFormShown = true"
                ) {{$t('cacheClear.addBtnText')}}
        // batch清緩存
        Drawer(title="Batch Purge" v-model="isBatchClearCacheFormShown" width="70" :styles="formDrawerStyles")
            BatchClearCacheForm(
                :esIndex="esIndex"
                :batchSelector="batchSelector"
                v-if="isBatchClearCacheFormShown"
                @batchSubmitComplete="isBatchClearCacheFormShown = false"
                :batchSelectorWith="batchSelectorWith"
                :givenBatchSearchFilters="givenBatchSearchFilters"
                :batchClearCachePage="'appProfile'"
                )
        DependencyObjectModal(:isDependencyObjectAlertShown="isDependencyObjectAlertShown" :dependencyConfig="dependencyConfig" @closeDependencyObjectAlert="isDependencyObjectAlertShown = false")
</template>
<script>
import Vue from "vue";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";
import BatchClearCacheForm from "@/components/BatchClearCacheForm";

import CopyText from "@/components/CopyText";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import DependencyObjectModal from "@/components/DependencyObjectModal";
import ExplainScheme from "@/components/PoptipInfos/ExplainScheme";
import ExplainURLRewrite from "@/components/PoptipInfos/ExplainURLRewrite";
import ExplainArgsRewrite from "@/components/PoptipInfos/ExplainArgsRewrite";
import ExplainCacheUrlRule from "@/components/PoptipInfos/ExplainCacheUrlRule";

import { getFormOptions } from "@/api/formoptions";

import {
    settingZoneExplain,
    appProfileName,
    serviceGroupName,
    usedOriginPolicies,
    origins,
    originScheme,
    portMappingType,
    originPort,
    customHostHeader,
    scheme,
    httpPort,
    httpsPort,
    redirecthttps,
    useHttp2,
    useHsts,
    description,
    maxServerNameInAppProfileCount,
    action,
} from "./fields.js";

Vue.component("TagList", TagList);
Vue.component("CopyText", CopyText);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("ExplainScheme", ExplainScheme);
Vue.component("ExplainURLRewrite", ExplainURLRewrite);
Vue.component("ExplainArgsRewrite", ExplainArgsRewrite);
Vue.component("ExplainCacheUrlRule", ExplainCacheUrlRule);

export default {
    name: "AppProfile",
    components: { RcmTable, TagList, BatchClearCacheForm, DependencyObjectModal },
    data() {
        return {
            searchView: "AppProfile",
            esIndex: "rcm-app-profiles",
            drawerTitleKey: "appProfileName",
            batchSelector: "FQDNSelector",
            batchSelectorWith: ["groupName", "servername"],
            givenBatchSearchFilters: [
                {
                    key: "groupName",
                    type: "string",
                    value: this.$store.state.queryGroupName,
                },
            ],
            isBatchClearCacheFormShown: false,
            formDrawerStyles: {
                height: "calc(100% - 120px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static",
            },
            dependencyConfig: {
                objectKey: "servicegroupnames",
                queryKey: "serviceGroupNames",
                path: "/servicegroup",
                name: "servicegroup",
                hasPermission: this.$can("write", "groupResourcesPermission", "ServiceGroup"),
            },
            isDependencyObjectAlertShown: false,
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [
                {
                    sectionKey: "cache",
                    isOpened: false,
                    sectionDescription:
                        "<p>Setup the cache behavior of path or file, the rule will take the order with <strong>Uncache > Cache</strong> </br>If omit the setting, we have the default cache extention of bmp, class, css, csv, doc, docx, ejs, eot, eps, gif, ico, jar, jpeg, jpg, js, mid, midi, otf, pdf, pict, pls, png, ppt, pptx, ps, svg, svgz, swf, tif, tiff, ttf, webp, woff, woff2, xls, xlsx.</p>",
                },
            ];
            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      appProfileName: appProfileName(this),
                      _id: {},
                      appProfileDomainsLength: {},
                      serviceGroupName: serviceGroupName(this),
                      maxServerNameInAppProfileCount: maxServerNameInAppProfileCount(this),
                      useOriginPolicy: {},
                      usedOriginPolicies: usedOriginPolicies(this),
                      origins: origins(this),
                      tags: {},
                      description: description(this),
                      scheme: {},
                      httpPort: httpPort(this),
                      httpsPort: httpsPort(this),
                      redirecthttps: {},
                      redirectHttpCode: {},
                      useHttp2: useHttp2(this),
                      useHsts: useHsts(this),
                      usedWafRules: {},
                      isUsedWafRules: {},
                      isUseOwasp: { showInTable: false },
                      owaspRuleName: { showInTable: false },
                      originscheme: originScheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      setCustomHostHeader: {},
                      customHostHeader: customHostHeader(this),
                      errorHtmlPageName: {},
                      upstreamTimeout: {},
                      // isEnabledKeepAliveToOrigin: {},
                      isEnabledCompressionToOrigin: {},
                      isEnabledUpstreamHttp11: {},
                      isInsertRidHeaderToOrigin: {},
                      isAcceptHttpV1: {},
                      websocketPath: {},
                      proxyBufferSize: {},
                      customVariables: {},
                      proxySetHeader: {},
                      isUpgradeInsecureRequest: {},
                      maxUploadSize: {},
                      rewriteUrlRules: {},
                      cacheUrlRules: {},
                      proxyCacheIgnoreArgs: { showInTable: false },
                      cusCachepath: { showInTable: false },
                      cusCachefile: { showInTable: false },
                      forceCusCachePath: { showInTable: false },
                      forceCusCacheFile: { showInTable: false },
                      cusNoncachepath: { showInTable: false },
                      cusNonachefile: { showInTable: false },
                      cusFollowCachePath: { showInTable: false },
                      cusFollowCacheFile: { showInTable: false },
                      cusCachepathExp: {},
                      cusCachepathSrvexp: {},
                      cusCachefileExp: {},
                      cusCachefileSrvexp: {},
                      defCachefileExp: {},
                      defCachefileSrvexp: {},
                      defCachefile: {},
                      defNoncachepath: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      appProfileName: appProfileName(this),
                      _id: {},
                      appProfileDomainsLength: {},
                      serviceGroupName: serviceGroupName(this),
                      // maxServerNameInAppProfileCount: maxServerNameInAppProfileCount(this),
                      useOriginPolicy: {},
                      usedOriginPolicies: usedOriginPolicies(this),
                      origins: origins(this),
                      tags: {},
                      description: description(this),
                      scheme: {},
                      httpPort: httpPort(this),
                      httpsPort: httpsPort(this),
                      redirecthttps: {},
                      redirectHttpCode: {},
                      useHsts: useHsts(this),
                      usedWafRules: {},
                      isUsedWafRules: {},
                      isUseOwasp: { showInTable: false },
                      owaspRuleName: { showInTable: false },
                      originscheme: originScheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      setCustomHostHeader: {},
                      customHostHeader: customHostHeader(this),
                      errorHtmlPageName: {},
                      upstreamTimeout: {},
                      // isEnabledKeepAliveToOrigin: {},
                      isEnabledCompressionToOrigin: {},
                      isEnabledUpstreamHttp11: {},
                      isInsertRidHeaderToOrigin: {},
                      isAcceptHttpV1: {},
                      websocketPath: {},
                      proxyBufferSize: {},
                      customVariables: {},
                      proxySetHeader: {},
                      isUpgradeInsecureRequest: {},
                      maxUploadSize: {},
                      rewriteUrlRules: {},
                      cacheUrlRules: {},
                      proxyCacheIgnoreArgs: { showInTable: false },
                      cusCachepath: { showInTable: false },
                      cusCachefile: { showInTable: false },
                      forceCusCachePath: { showInTable: false },
                      forceCusCacheFile: { showInTable: false },
                      cusNoncachepath: { showInTable: false },
                      cusNonachefile: { showInTable: false },
                      cusFollowCachePath: { showInTable: false },
                      cusFollowCacheFile: { showInTable: false },
                      cusCachepathExp: {},
                      cusCachepathSrvexp: {},
                      cusCachefileExp: {},
                      cusCachefileSrvexp: {},
                      defCachefileExp: {},
                      defCachefileSrvexp: {},
                      defCachefile: {},
                      defNoncachepath: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$store.state.rcmTableIsInitComplete": function (newVal, oldVal) {
            if (this.$router.currentRoute.query.create && newVal) {
                this.$refs.rcmTable.manipulateItem("", "create");
            }
        },
    },
    methods: {
        async checkObjectCanBeCreated() {
            let result = await getFormOptions(
                `/${this.dependencyConfig.objectKey}?groupName=${this.$store.state.queryGroupName}&${this.dependencyConfig.queryKey}=***`
            );
            this.isDependencyObjectAlertShown = result.data.options.length == 0;
        },
    },
    created() {
        this.checkObjectCanBeCreated();
        // this.isAdmin = this.$store.state.userData.privilege == "admin";
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/AppProfile/Page.vue